<template>
  <svg class="icon icon--pointer" width="22px" height="22px" viewBox="0 0 22 22" version="1.1" xmlns="http://www.w3.org/2000/svg">
    <g stroke="none" stroke-width="1" fill="none" fill-rule="evenodd">
      <g transform="translate(-242.000000, -702.000000)" stroke="#FFFFFF">
        <g transform="translate(55.000000, 685.000000)">
          <g transform="translate(198.000000, 28.000000) rotate(-180.000000) translate(-198.000000, -28.000000) translate(187.000000, 18.000000)">
            <polygon fill="#FFFFFF" fill-rule="nonzero" points="0.532522292 9.60091559 0 10.122965 0.532522292 10.6450143 10.0751798 20 10.7592946 19.2059429 1.09061489 9.87128247 1.09061489 10.6450143 11 0.771553108 10.3260434 0"></polygon>
            <path d="M1,10 L22,10" stroke-width="2"></path>
          </g>
        </g>
      </g>
    </g>
  </svg>
</template>

<script>
  export default{
    data(){
      return{}
    }
  }
</script>



// WEBPACK FOOTER //
// src/components/icons/Pointer.vue